import { Button, Divider, Paper } from '@mui/material';
import { a11yProps } from 'CommonComponents/StyledTabs';
import { StyledTab } from 'CommonComponents/StyledTabs.js';
import { StyledTabs } from 'CommonComponents/StyledTabs.js';
import { buttonUnselectedStyle } from 'HelperFiles/Constants';
import { buttonSelectedStyle } from 'HelperFiles/Constants';
import { getAllIncidents } from 'HelperFiles/DashboardHelper';
import AnalyticsListingAHF from 'Pages/AHFDashboard/AnalyticsListingAHF';
import AnalyticsSummaryAHF from 'Pages/AHFDashboard/AnalyticsSummaryAHF';
import TopBarFilterAHF from 'Pages/AHFDashboard/TopBarFilterAHF';
import AnalyticsSummaryGE from 'Pages/GEDashboard/AnalyticsSummaryGE';
import InventoryCounting from 'Pages/GEDashboard/InventoryCounting';
import TopBarFilterGE from 'Pages/GEDashboard/TopBarFilterGE';
import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getApplicationConfig } from 'Redux/DashboardVariables';
import AnalyticsListing from './AnalyticsListing';
import AnalyticsSummary from './AnalyticsSummary';
import TopBarFilterOne from './TopBarFilterOne';

const ManuDashboard = () => {
  const applicationConfig = useSelector(getApplicationConfig);
  const [tabValue, setTabValue] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState('Operational Efficiency');

  const handleChangeTabs = (event, newValue) => {
    setTabValue(newValue);
  };

  // console.log('main log manu dashboard: ', applicationConfig, selectedCategory,
  //   applicationConfig === 'DashboardManufacturingBundleGEAppliances' &&
  //     selectedCategory === 'Operational Efficiency'
  //     ? '<AnalyticsSummaryGE />'
  //     : applicationConfig === 'DashboardManufacturingBundleGEAppliances' &&
  //       selectedCategory === 'Inventory Counting'
  //       ? '<InventoryCounting />'
  //       : '<AnalyticsSummary />');

  return (
    <div style={{ fontFamily: `'Lato', sans-serif` }}>
      <Paper elevation={0}>
        <StyledTabs
          value={tabValue}
          onChange={handleChangeTabs}
          aria-label="styled tabs example"
        >
          <StyledTab label="Analytics Summary" {...a11yProps(0)} />
          <StyledTab label="Event Replay" {...a11yProps(1)} />
          {(applicationConfig === 'DashboardManufacturingBundleGEAppliances' ||
            applicationConfig === 'DashboardManufacturingBundleAHF')
            &&
            <Divider orientation="vertical" flexItem />
          }
          {
            applicationConfig === 'DashboardManufacturingBundleGEAppliances'
              ?
              <div>
                <Divider orientation="vertical" flexItem />
                <TopBarFilterGE hideCameraSelection />
              </div>
              : applicationConfig === 'DashboardManufacturingBundleAHF'
                ? <div>
                  <Divider orientation="vertical" flexItem />
                  <TopBarFilterAHF />
                </div>
                : null
          }
        </StyledTabs>
      </Paper>

      {
        !(applicationConfig === 'DashboardManufacturingBundleGEAppliances' ||
          applicationConfig === 'DashboardManufacturingBundleAHF')
        &&
        <TopBarFilterOne />
      }

      {tabValue === 0 && applicationConfig === 'DashboardManufacturingBundleGEAppliances' &&
        <>
          <div style={{
            width: '100%',
            padding: '10px',
            display: 'flex',
            alignItems: 'center',
            marginTop: '10px',
            backgroundColor: 'white',
            boxSizing: 'border-box'
          }}>
            <span style={{
              color: 'gray',
              marginRight: '10px',
              fontSize: '14px'
            }}
            >Filter By Category</span>
            <Button
              size='small'
              style={selectedCategory === 'Operational Efficiency'
                ? buttonSelectedStyle
                : buttonUnselectedStyle}
              onClick={() => setSelectedCategory('Operational Efficiency')}
            >
              Operational Efficiency
            </Button>
            <Button
              size='small'
              style={selectedCategory === 'Inventory Counting'
                ? buttonSelectedStyle
                : buttonUnselectedStyle}
              onClick={() => setSelectedCategory('Inventory Counting')}
            >
              Inventory Counting
            </Button>
          </div>
          {
            selectedCategory === 'Operational Efficiency'
              ? <AnalyticsSummaryGE />
              : <InventoryCounting />
          }

        </>
      }
      {tabValue === 0 && applicationConfig === 'DashboardManufacturingBundleAHF' &&
        <>
          <div style={{
            width: '100%',
            padding: '10px',
            display: 'flex',
            alignItems: 'center',
            marginTop: '10px',
            backgroundColor: 'white',
            boxSizing: 'border-box'
          }}>
            <span style={{
              color: 'gray',
              marginRight: '10px',
              fontSize: '14px'
            }}
            >Filter By Category</span>
            <Button
              size='small'
              style={buttonSelectedStyle}
            >
              Quality Control
            </Button>
          </div>
          {
            <AnalyticsSummaryAHF />
          }

        </>
      }
      {tabValue === 0 &&
        applicationConfig !== 'DashboardManufacturingBundleGEAppliances' &&
        applicationConfig !== 'DashboardManufacturingBundleAHF' &&
        <AnalyticsSummary />
      }


      {
        tabValue === 1 && applicationConfig !== 'DashboardManufacturingBundleAHF' &&
        <AnalyticsListing />
      }
      {
        tabValue === 1 && applicationConfig === 'DashboardManufacturingBundleAHF' &&
        <AnalyticsListingAHF />
      }

    </div>
  );
}

export default ManuDashboard;